import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Home,
  Users,
  Bus,
  UserCheck,
  LogOut,
  ChevronDown,
  ChevronRight,
  RefreshCw,
  School2,
} from "lucide-react";

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [branchOpen, setBranchOpen] = useState(true);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  const branches = [
    {
      label: "Perumbakkam",
      path: "/branches/perumbakkam",
    },
    {
      label: "KVR Campus",
      path: "/branches/kvr-campus",
    },
    {
      label: "Thiruvanmiyur",
      path: "/branches/thiruvanmiyur",
    },
    {
      label: "Thirumudivakkam",
      path: "/branches/thirumudivakkam",
    },
    {
      label: "Hyderabad",
      path: "/branches/hyderabad",
    },
  ];

  const menuItems = [
    { label: "Academics", path: "/academics", icon: <Users size={18} /> },
    { label: "Transport", path: "/transport", icon: <Bus size={18} /> },
    { label: "Human Resource", path: "/hr", icon: <UserCheck size={18} /> },
    {
      label: "Best School",
      path: "/best-school",
      icon: <School2 size={18} />,
    },
  ];

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Redirect to login
    navigate("/", { replace: true });
    setShowLogoutConfirm(false);
  };

  return (
   <>
  <div
    className={`h-screen bg-[#1E293B] text-white flex flex-col transition-all duration-300 ${
      collapsed ? "w-[70px]" : "w-[220px]"
    }`}
  >
    {/* Header */}
    <div
      className="flex items-center justify-between px-4 py-4 cursor-pointer"
      onClick={() => setCollapsed((prev) => !prev)}
    >
      <img
          src="/Logooo.svg"
          alt="logo"
          className="h-12 w-auto max-w-[150px] mx-auto"
        />
      {!collapsed && (
        <img
          src="/screenshot.jpg"
          alt="logo"
          className="h-12 w-auto max-w-[150px] mx-auto"
        />
      )}
    </div>

    {/* Menu */}
    <div className="flex-1 px-2 py-8 space-y-1 overflow-y-auto">
      <NavLink
        to="/dashboard"
        className={({ isActive }) =>
          `flex items-center gap-3 px-3 py-2 rounded-md transition ${
            isActive
              ? "bg-white text-black font-medium"
              : "hover:bg-white/10"
          }`
        }
      >
        <Home size={18} onClick={() => setCollapsed((prev) => !prev)}/>
        {!collapsed && <span className="text-sm">Dashboard</span>}
      </NavLink>

      <div>
        <button
          onClick={() => setBranchOpen((prev) => !prev)}
          className="w-full flex items-center justify-between px-3 py-3 rounded-md bg-[#343B59] hover:bg-[#3d4567] transition"
        >
          <div className="flex items-center gap-3">
            <RefreshCw size={18} className="text-white" onClick={() => setCollapsed((prev) => !prev)} />
            {!collapsed && (
              <span className="text-sm font-medium">School Branches</span>
            )}
          </div>
          {!collapsed &&
            (branchOpen ? (
              <ChevronDown size={18} />
            ) : (
              <ChevronRight size={18} />
            ))}
        </button>

        {branchOpen && !collapsed && (
          <div className="mt-2 ml-4 space-y-1">
            {branches.map((branch) => (
              <NavLink
                key={branch.label}
                to={branch.path}
                className={({ isActive }) =>
                  `block px-4 py-3 rounded-md text-sm transition ${
                    isActive
                      ? "bg-white/40 font-medium"
                      : "text-white/60 hover:text-white"
                  }`
                }
              >
                {branch.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>

      {menuItems.map((item) => (
        <NavLink
          key={item.label}
          to={item.path}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2 rounded-md transition ${
              isActive
                ? "bg-white text-black font-medium"
                : "hover:bg-white/10"
            }`
          } 
        >
         <span onClick={() => setCollapsed((prev) => !prev)}> {item.icon}</span>
          {!collapsed && <span className="text-sm">{item.label}</span>}
        </NavLink>
      ))}
    </div>

    {/* Bottom Section with Logout */}
    <div className="px-2 pb-4 pt-4 border-t border-white/10 mt-auto">
      <button
        onClick={() => setShowLogoutConfirm(true)}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-md transition hover:bg-red-500/20 text-white"
      >
        <LogOut size={18} />
        {!collapsed && <span className="text-sm">Log Out</span>}
      </button>
    </div>
  </div>

  {/* Logout Confirmation Modal */}
  {showLogoutConfirm && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Confirm Logout
        </h3>
        <p className="text-gray-600 mb-6">
          Are you sure you want to log out?
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={() => setShowLogoutConfirm(false)}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            className="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  )}
</>
  );
}
